import { reviews } from "@/mocks/reviews";

export default function ReviewSection() {
  const [featured, ...rest] = reviews;
  return (
    <section id="review" className="mx-auto max-w-7xl scroll-mt-28 px-4 py-10 md:px-6 md:py-14">
      <div className="mb-2 flex items-center gap-2">
        <span className="h-5 w-1 bg-accent-500" />
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          反转复盘 · 编辑部专栏
        </h2>
      </div>
      <p className="mb-6 text-xs text-foreground-600 md:text-sm">
        先给出完整来龙去脉，再拆情绪拐点。复盘不为站队，只为把整件事说清楚、想明白。
      </p>

      {/* 主复盘横幅 */}
      <a href="#top" className="group relative block overflow-hidden">
        <div className="relative h-64 md:h-96">
          <img
            src={featured.cover}
            alt={featured.title}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/50 to-transparent" />
          <div className="absolute inset-0 flex flex-col justify-end p-5 md:justify-center md:p-10 lg:max-w-[60%]">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
                {featured.kicker}
              </span>
              <span className="rounded-md bg-background-50/15 px-2 py-0.5 text-xs font-semibold text-background-50 backdrop-blur">
                {featured.tag}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
              {featured.title}
            </h3>
            <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-100/90 sm:block">
              {featured.summary}
            </p>
            <p className="mt-3 flex items-center gap-1 text-xs text-accent-300">
              <i className="ri-edit-2-line" /> 复盘编辑部 · {featured.author}
            </p>
          </div>
        </div>
      </a>

      {/* 副复盘卡 */}
      <div className="mt-5 grid gap-5 md:grid-cols-2">
        {rest.map((r, i) => (
          <a
            key={r.id}
            href="#top"
            className="group flex flex-col border border-background-200 bg-background-50 transition-colors hover:border-background-300 sm:flex-row"
          >
            <div className="relative h-44 shrink-0 overflow-hidden sm:h-auto sm:w-48">
              <img
                src={r.cover}
                alt={r.title}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center bg-accent-500 text-sm font-bold text-background-50">
                0{i + 2}
              </span>
            </div>
            <div className="flex flex-col justify-center p-4">
              <span className="text-[11px] font-medium uppercase tracking-wide text-accent-700">
                {r.kicker}
              </span>
              <h4 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">
                {r.title}
              </h4>
              <p className="mt-2 hidden text-xs leading-relaxed text-foreground-600 lg:block">
                {r.summary}
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-user-3-line" /> {r.author}
                </span>
                <span className="flex items-center gap-1 font-medium text-primary-600">
                  <i className="ri-arrow-right-line" /> 全文复盘
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}